export default {
	//
	// components
	//

	//
	// SidebarMeetingCommitments
	//
	SidebarMeetingCommitments_noCommitmentsMessage: "No action items associated with this meeting.",

	//
	// SelectedMeetingDetails
	//
	SelectedMeetingDetails_tooltip: "The context panel provides the information you and your team need to run the most effective meeting.",
	SelectedMeetingDetails_title: "Meeting Context",
	SelectedMeetingDetails_privateNotesTitle: "Your Private Notes",
	SelectedMeetingDetails_teamGoalsTitle: "Team Goals",
	SelectedMeetingDetails_teamGoalsDescription: "Click on a goal to view its details or make changes.",
	SelectedMeetingDetails_workStylesTitle: "Attendees",
	SelectedMeetingDetails_expandAll: "Expand all",
	SelectedMeetingDetails_collapseAll: "Collapse all",
	SelectedMeetingDetails_noTeamDescription: "To view team goals, you must first connect a team to this meeting.",
	SelectedMeetingDetails_teamNoGoalsDescription: "Looks like your team isn’t currently tracking any goals. Create goals to keep your team focused on work that matters, while tracking progress toward key results.",
	SelectedMeetingDetails_createGoalButton: "Add a goal",

	//
	// MeetingNotesField
	//
	MeetingNotesField_privateNotePlaceholder: "Add some private notes...",
	MeetingNotesField_disclaimerText: "Private notes are only visible to you when this field is in focus. They are saved privately in this meeting, and are never shared with your teammates.",
	MeetingNotesField_showEditNotesLabel: "Click to show/edit notes",
	MeetingAttendees_descriptionText: "Click on an attendee to learn more about their individual work style.",

	//
	// TeamGoalCondensed
	//
	TeamGoalCondensed_progressLabel: "Progress",
	TeamGoalCondensed_pacingLabel: "Pacing",
	TeamGoalCondensed_confidenceLabel: "Confidence",

	//
	// AttendeeWorkStyle
	//
	AttendeeWorkStyle_whatComesNaturallyLabel: "What comes naturally to {name}",
	AttendeeWorkStyle_whatEnergizesLabel: "What energizes {name}",
	AttendeeWorkStyle_whatDrainsLabel: "What drains {name}",
	AttendeeWorkStyle_noAssessmentLabel: "Has not completed work style assessment",

	//
	// MeetingDurationChip
	//
	MeetingDurationChip_timerText: "{time} min",
	MeetingDurationChip_timerOvertimeText: "+ {time} min",

	//
	// TopicDurationChip
	//
	TopicDurationChip_timerText: "{time} min",

	//
	// Topic
	//
	Topic_clickToEditLabel: "Click any outcome to edit.",

	//
	// ScheduleTopicButtons
	//
	ScheduleTopicButtons_addDescriptionButton: "Add description",
	ScheduleTopicButtons_addNoteButton: "Add note",
	ScheduleTopicButtons_cancelButton: "Cancel",
	ScheduleTopicButtons_deferButton: "Defer",
	ScheduleTopicButtons_nextTopicButton: "Next topic",
	ScheduleTopicButtons_resumeTopicButton: "Resume topic",
	ScheduleTopicButtons_saveButton: "Save",
	ScheduleTopicButtons_startTopicButton: "Start topic",
	ScheduleTopicButtons_undeferButton: "Undefer",

	//
	// DeferredMeetingTopic
	//
	DeferredMeetingTopic_startTopicButton: "Start topic",
	DeferredMeetingTopic_deferredButton: "Deferred to next meeting",

	//
	// OutcomeTypeMenu
	//
	OutcomeFieldMixin_noteOption: "Note",
	OutcomeFieldMixin_commitmentOption: "Action Item",
	OutcomeFieldMixin_decisionOption: "Decision",
	OutcomeFieldMixin_deleteConfirmationLabel: "Are you sure you want to delete this {outcomeType}?",
	OutcomeFieldMixin_cancelDeleteButton: "No, cancel",
	OutcomeFieldMixin_confirmDeleteButton: "Yes, delete",
	OutcomeFieldMixin_noteLabel: "note",
	OutcomeFieldMixin_decisionLabel: "decision",
	OutcomeFieldMixin_commitmentLabel: "action item",

	//
	// NoteOutcomeField
	//
	NoteMarkdownField_notePlaceholder: "Add notes and outcomes here",

	//
	// DecisionOutcomeField
	//
	DecisionMarkdownField_decisionPlaceholder: "What have you decided?",

	//
	// CommitmentOutcomeField
	//
	CommitmentOutcomeField_commitmentPlaceholder: "What are you committing to do?",
	CommitmentEditor_dueDatePlaceholder: "Due date",
	CommitmentEditor_noAssigneeLabel: "No assignee",

	//
	// FinalizeMeetingButton
	//
	FinalizeMeetingButton_finalizeButton: "Send and finalize report",
	FinalizeMeetingButton_finalizeMenuTitle: "Send and Finalize Report?",
	FinalizeMeetingButton_finalizeMenuDescription1: "Sending the meeting report now finalizes meeting outcomes and locks the report. Be sure to make any edits prior to sending.",
	FinalizeMeetingButton_finalizeMenuDescription2: "If you choose not to send it now, we will automatically finalize and send the report to attendees 24 hours after the meeting ended.",
	FinalizeMeetingButton_sendReportButton: "Send report now",
	FinalizeMeetingButton_dontSendButton: "Don’t send now",
	FinalizeMeetingButton_confirmationButton: "Report sent!",

	//
	// StandbyField
	//
	StandbyField_placeholder: "Add notes and outcomes here",
};



// WEBPACK FOOTER //
// ./src/lang/en/meeting.js